import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {TreatmentDefinitionModel} from '../../../api/entity/treatmentDefinitionModel';
import {TreatmentDefinitionConverter} from '../../../api/entity/converter/treatmentDefinition.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class TreatmentDefinitionDataService extends AbstractDataServiceV2<TreatmentDefinitionModel, TreatmentDefinitionConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: TreatmentDefinitionConverter) {
        super('TreatmentDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
